module.exports = __webpack_public_path__ + "img/cqt1.e703daaf.jpg";